import { css } from '@emotion/css';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import { Show, Switch } from 'solid-js'
import { LayoutSelector } from 'Shared/backend/widgets/LayoutSelector';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Component, AddWrap } from 'Shared/backend/widgets/Component';
import { Match } from 'solid-js';
import { useLayout } from 'Shared/backend/LayoutProvider';


export function SeparatedComponentAndSelector(P)
{
	const sw = useStore();
	const lo = useLayout();

//HACK first ...P	

//FIXME protect against empty Style component	

	return (
		<Switch>
			<Match when={!lo.layout() && P.layout=='styles'}>
				<StoreProvider {...sw} location={[...sw.location,'content']}>
					<SeparatedComponentAndSelector {...P} {...P.content} />
				</StoreProvider>
			</Match>
			<Match when={true}>
				<Show when={lo.layout()}>
					<div class={css({display:'flex', flexWrap:'wrap', justifyContent:'space-between', alignItems:'flex-start'})}>
						<LabelOnLeftWrap label='Component:' narrow>
							<LayoutSelector layout={P.layout} options={P.options} isTop required />
						</LabelOnLeftWrap>
						<AddWrap {...P} />
					</div>
				</Show>

				<Component {...P} />
			</Match>
		</Switch>
	);
}

